/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { AdminThreadsControllerFindOneQueryResponse, AdminThreadsControllerFindOnePathParams, AdminThreadsControllerFindOneQueryParams } from "../../models/adminThreadsController/AdminThreadsControllerFindOne";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { adminThreadsControllerFindOne } from "../../clients/admin-threadsService/adminThreadsControllerFindOne";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const adminThreadsControllerFindOneQueryKey = (threadId: AdminThreadsControllerFindOnePathParams["threadId"], params: AdminThreadsControllerFindOneQueryParams = {}) => [{
  url: '/api/v1/admin/threads/:threadId',
  params: {
    threadId: threadId
  }
}, ...(params ? [params] : [])] as const;
export type AdminThreadsControllerFindOneQueryKey = ReturnType<typeof adminThreadsControllerFindOneQueryKey>;
export function adminThreadsControllerFindOneQueryOptions(threadId: AdminThreadsControllerFindOnePathParams["threadId"], params?: AdminThreadsControllerFindOneQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = adminThreadsControllerFindOneQueryKey(threadId, params);
  return queryOptions<AdminThreadsControllerFindOneQueryResponse, ResponseErrorConfig<Error>, AdminThreadsControllerFindOneQueryResponse, typeof queryKey>({
    enabled: !!threadId,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return adminThreadsControllerFindOne(threadId, params, config);
    }
  });
}

/**
 * @summary Read a customer thread and its conversation history
 * {@link /api/v1/admin/threads/:threadId}
 */
export function useAdminThreadsControllerFindOne<TData = AdminThreadsControllerFindOneQueryResponse, TQueryData = AdminThreadsControllerFindOneQueryResponse, TQueryKey extends QueryKey = AdminThreadsControllerFindOneQueryKey>(threadId: AdminThreadsControllerFindOnePathParams["threadId"], params?: AdminThreadsControllerFindOneQueryParams, options: {
  query?: Partial<QueryObserverOptions<AdminThreadsControllerFindOneQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? adminThreadsControllerFindOneQueryKey(threadId, params);
  const query = useQuery({
    ...adminThreadsControllerFindOneQueryOptions(threadId, params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}